var router = require('pjax').Router;
var form = require('./form.js');

router.get('discount/:any', form);
